import { render, staticRenderFns } from "./TeacherMonthRecordsList.vue?vue&type=template&id=4944049e&scoped=true"
import script from "./TeacherMonthRecordsList.vue?vue&type=script&lang=js"
export * from "./TeacherMonthRecordsList.vue?vue&type=script&lang=js"
import style0 from "./TeacherMonthRecordsList.vue?vue&type=style&index=0&id=4944049e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4944049e",
  null
  
)

export default component.exports